<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
  }
}
</script>

<style>
#app {
  font-family: "Sora", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #202020;
  overflow-x: hidden;
}
.hightlight{
  font-size: 14px;
  background: #FC53001A;
  border-radius: 10px;
  color: #202020 !important;
  padding: 5px 15px;
  margin-bottom: 20px;
}
.hightlight-light{
  font-size: 14px;
  background: #FFFFFF1A;
  border-radius: 10px;
  color: #FFF;
  padding: 5px 15px;
  margin-bottom: 20px;
}

.custom-select{
  width: 100%;
    max-width: 395px;
    height: 45px;
    border-radius: 10px;
    border: 1px solid #fff;
    background: transparent;
    color: #fff !important;
    padding-left:20px;
    padding-right:40px;
    -moz-appearance: none; 
    -webkit-appearance: none; 
    appearance: none;
    font-size: 20px;
}
.custom-select{
  background: url('./assets/inicio/chevron.png');
  background-position: 95% center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  
}

.footer textarea::placeholder {
  color: #fff !important;
  opacity: 1; /* Firefox */
}

.footer textarea::-ms-input-placeholder { /* Edge 12 -18 */
  color: #fff !important;
}

.custom-file-label {
    white-space: normal !important;
    overflow-x: hidden;
    width: 100%;
    background: white;
    padding: 50px 10px;
    border: 2px #386CE7 dashed;
    border-radius: 10px;
}

.custom-file-input{
    visibility: hidden;
    height: 0px;
}
</style>
